import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import DashboardLayout from '../components/DashboardLayout';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Settings() {
  const { token, user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    phone: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        full_name: user.full_name || '',
        phone: user.phone || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`${API}/profile`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Profil yeniləndi');
    } catch (error) {
      toast.error('Əməliyyat uğursuz oldu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="max-w-2xl" data-testid="settings-page">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Parametrlər</h1>
          <p className="text-muted-foreground mt-1">Profil məlumatlarınızı idarə edin</p>
        </div>

        <div className="bg-white rounded-xl border border-border p-6">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="profile-form">
            <div>
              <Label htmlFor="full_name">Ad və Soyad</Label>
              <Input
                id="full_name"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                required
                data-testid="fullname-input"
              />
            </div>

            <div>
              <Label htmlFor="phone">Telefon</Label>
              <Input
                id="phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+994501234567"
                data-testid="phone-input"
              />
            </div>

            <div>
              <Label>Email</Label>
              <Input value={user?.email || ''} disabled />
              <p className="text-xs text-muted-foreground mt-1">Email dəyişdirilə bilməz</p>
            </div>

            <Button type="submit" className="w-full" disabled={loading} data-testid="submit-profile-button">
              {loading ? 'Saxlanılır...' : 'Yenilə'}
            </Button>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
}